
export const privacyPolicy = {
  title: "ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ И ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ",
  subtitle: "интернет-магазина g-factory.kz и розничной сети бутиков G-Square",
  operator: "ТОО «Chronos Trading», Республика Казахстан",
  edition: "Редакция от «10» сентября 2026 года",
  sections: [
    {
      id: "1",
      title: "НАЗНАЧЕНИЕ И ОБЛАСТЬ ДЕЙСТВИЯ ПОЛИТИКИ",
      blocks: [
        {
          type: "clause",
          num: "1.1",
          text: "Настоящая Политика конфиденциальности и обработки персональных данных (далее — Политика) определяет позицию, намерения и порядок действий Товарищества с ограниченной ответственностью «Chronos Trading» (далее — Оператор, Владелец Сайта) при сборе, обработке, хранении, передаче, защите и уничтожении персональных данных пользователей сайта https://g-factory.kz (далее — Сайт), а также при сборе и использовании информации, получаемой с помощью файлов cookie и сведений об IP-адресе Пользователя."
        },
        {
          type: "clause",
          num: "1.2",
          text: "Политика разработана в соответствии с Конституцией Республики Казахстан, Гражданским кодексом Республики Казахстан, Законом Республики Казахстан от 21 мая 2013 года № 94-V «О персональных данных и их защите» (далее — Закон о персональных данных), в редакции, действующей на дату утверждения настоящей Политики, включая изменения, введённые в действие с 12 июля и 25 августа 2026 года, Правилами сбора, обработки персональных данных, Правилами осуществления собственником и (или) оператором, а также третьим лицом мер по защите персональных данных, Правилами определения собственником и (или) оператором перечня персональных данных, необходимого и достаточного для выполнения осуществляемых ими задач, Правилами осуществления уведомления субъектов персональных данных о нарушении безопасности персональных данных, Законом Республики Казахстан «О защите прав потребителей», правилами осуществления электронной торговли, а также иными нормативными правовыми актами Республики Казахстан."
        },
        {
          type: "clause",
          num: "1.3",
          text: "Целями Политики являются обеспечение соблюдения и защита прав и свобод человека и гражданина, в частности права на неприкосновенность частной жизни, личную и семейную тайну, защиту чести и достоинства, а также информирование Пользователя о том, какие сведения о нём собираются, для чего, кому передаются и как их можно изменить или удалить."
        },
        {
          type: "clause",
          num: "1.4",
          text: "Действие Политики распространяется на все персональные данные, которые Оператор получает:",
          items: [
            "при оформлении, обработке и исполнении заказов на Сайте;",
            "при регистрации и использовании личного кабинета;",
            "при подписке на информационную рассылку;",
            "при публикации отзывов и прикреплении к ним изображений;",
            "при обращении в службу поддержки, в том числе через мессенджеры WhatsApp и Telegram, социальные сети и по электронной почте;",
            "при направлении отклика на вакансию через форму на Сайте;",
            "при обращении в сервисный центр Оператора;",
            "при обслуживании покупателей в розничных бутиках сети G-Square;",
            "автоматически — при посещении Сайта, посредством файлов cookie, счётчиков веб-аналитики и записи сведений об IP-адресе."
          ]
        },
        {
          type: "clause",
          num: "1.5",
          text: "Использование Пользователем Сайта, оформление заказа, регистрация личного кабинета либо иное предоставление своих данных Оператору означает, что Пользователь ознакомился с настоящей Политикой и принимает её условия. В случае несогласия с условиями Политики Пользователь обязан прекратить использование Сайта и не предоставлять Оператору свои персональные данные."
        },
        {
          type: "clause",
          num: "1.6",
          text: "Настоящая Политика касается исключительно вопросов обработки информации, указанной в пункте 1.1, не является офертой и не свидетельствует о намерении Оператора заключить с Пользователем какие-либо договоры или соглашения. Условия приобретения товаров определяются публичной офертой, размещённой по адресу https://g-factory.kz/publicOffer."
        },
        {
          type: "clause",
          num: "1.7",
          text: "Действующая редакция Политики публикуется в свободном доступе, без регистрации и авторизации, по адресу: https://g-factory.kz/privacyPolicy."
        },
        {
          type: "clause",
          num: "1.8",
          text: "Контроль за исполнением требований настоящей Политики осуществляет лицо, ответственное за организацию обработки персональных данных, назначаемое приказом руководителя Оператора."
        }
      ]
    },
    {
      id: "2",
      title: "СВЕДЕНИЯ ОБ ОПЕРАТОРЕ",
      blocks: [
        {
          type: "clause",
          num: "2.1",
          text: "Владельцем Сайта, собственником и оператором персональных данных для целей настоящей Политики является:"
        },
        {
          type: "field",
          label: "Наименование",
          value: "Товарищество с ограниченной ответственностью «Chronos Trading»"
        },
        {
          type: "field",
          label: "БИН",
          value: "110440018801"
        },
        {
          type: "field",
          label: "Юридический адрес",
          value: "Республика Казахстан, город Алматы, улица Желтоксан, дом 148"
        },
        {
          type: "field",
          label: "Адрес электронной почты",
          value: "shop@g-factory.kz"
        },
        {
          type: "field",
          label: "Абонентские номера",
          value: "+7 (777) 393 80 22"
        },
        {
          type: "field",
          label: "Адрес Сайта",
          value: "https://g-factory.kz"
        },
        {
          type: "clause",
          num: "2.2",
          text: "Оператор осуществляет реализацию товаров дистанционным способом через Сайт, а также через розничные бутики сети G-Factory в городе Алматы, и оказывает услуги сервисного обслуживания часов."
        },
        {
          type: "clause",
          num: "2.3",
          text: "Обращения Пользователей по вопросам обработки персональных данных, включая запросы о составе обрабатываемых данных, требования об их уточнении, блокировании или уничтожении, а также заявления об отзыве согласия, направляются на адрес электронной почты shop@g-factory.kz с указанием темы «Персональные данные» либо в письменной форме по юридическому адресу Оператора, указанному в пункте 2.1."
        },
        {
          type: "clause",
          num: "2.4",
          text: "Лицо, ответственное за организацию обработки персональных данных, осуществляет внутренний контроль за соблюдением Оператором и его работниками законодательства Республики Казахстан о персональных данных и их защите, доводит до сведения работников требования указанного законодательства, а также контролирует приём и обработку обращений субъектов персональных данных и их законных представителей."
        }
      ]
    },
    {
      id: "3",
      title: "ТЕРМИНЫ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ",
      blocks: [
        {
          type: "clause",
          num: "3.1",
          text: "Персональные данные — сведения или совокупность сведений о субъекте персональных данных, дополненные одним или несколькими идентификаторами персональных данных."
        },
        {
          type: "clause",
          num: "3.2",
          text: "Идентификатор персональных данных — информация, позволяющая идентифицировать субъекта персональных данных или связать отдельные наборы данных о нём в совокупность сведений, позволяющих идентифицировать данного субъекта. В соответствии с законодательством Республики Казахстан к идентификаторам персональных данных относятся: 1) фамилия, имя, отчество (если оно указано в документе, удостоверяющем личность) в совокупности; 2) индивидуальный идентификационный номер; 3) изображение лица субъекта; 4) биометрический вектор лица субъекта или его производные, которые могут быть восстановлены до первоначального значения."
        },
        {
          type: "clause",
          num: "3.3",
          text: "Субъект персональных данных (Пользователь) — физическое лицо, к которому относятся персональные данные, использующее Сайт и (или) приобретающее товары либо услуги Оператора, в том числе в розничных бутиках сети."
        },
        {
          type: "clause",
          num: "3.4",
          text: "Оператор (Владелец Сайта) — юридическое лицо, самостоятельно или совместно с другими лицами организующее и осуществляющее сбор, обработку и защиту персональных данных, определяющее цели обработки, состав обрабатываемых персональных данных и совершаемые с ними действия."
        },
        {
          type: "clause",
          num: "3.5",
          text: "Третье лицо — лицо, не являющееся субъектом персональных данных, Оператором или собственником, но связанное с ними обстоятельствами или правовыми актами в отношении персональных данных."
        },
        {
          type: "clause",
          num: "3.6",
          text: "Обработка персональных данных — любое действие или совокупность действий, совершаемых с персональными данными с использованием средств автоматизации или без их использования, включая сбор, запись, систематизацию, накопление, хранение, изменение, дополнение, уточнение, использование, распространение, обезличивание, блокирование и уничтожение персональных данных."
        },
        {
          type: "clause",
          num: "3.7",
          text: "Автоматизированная обработка персональных данных — обработка персональных данных с использованием средств вычислительной техники."
        },
        {
          type: "clause",
          num: "3.8",
          text: "Обезличивание персональных данных — действия, в результате которых невозможно определить принадлежность персональных данных конкретному субъекту без использования дополнительной информации."
        },
        {
          type: "clause",
          num: "3.9",
          text: "Персональные данные ограниченного доступа — персональные данные, доступ к которым ограничен законодательством Республики Казахстан."
        },
        {
          type: "clause",
          num: "3.10",
          text: "Общедоступные персональные данные — персональные данные, доступ к которым является свободным с согласия субъекта либо на которые в соответствии с законодательством Республики Казахстан не распространяется требование соблюдения конфиденциальности."
        },
        {
          type: "clause",
          num: "3.11",
          text: "Трансграничная передача персональных данных — передача персональных данных на территорию иностранного государства."
        },
        {
          type: "clause",
          num: "3.12",
          text: "Сайт — совокупность информации, содержащейся в информационной системе, доступ к которой обеспечивается через сеть Интернет по доменному имени https://g-factory.kz, включая все его страницы и разделы."
        },
        {
          type: "clause",
          num: "3.13",
          text: "Личный кабинет (Профиль) — персонализированный раздел Сайта, содержащий данные Пользователя и предоставляющий доступ к персонализированным функциям Сайта; доступ осуществляется с помощью логина (адреса электронной почты) и пароля, выбранных Пользователем."
        },
        {
          type: "clause",
          num: "3.14",
          text: "Заказ на Сайте — выраженное с помощью функций Сайта намерение Пользователя приобрести товары Оператора на условиях и в порядке, предусмотренных публичной офертой."
        },
        {
          type: "clause",
          num: "3.15",
          text: "Рассылка — направление Оператором Пользователю сообщений информационного и (или) рекламного характера по электронной почте, в виде SMS-сообщений либо через мессенджеры, по заранее сформированному списку адресатов."
        },
        {
          type: "clause",
          num: "3.16",
          text: "Файлы cookie — небольшие фрагменты данных, отправляемые веб-сервером и сохраняемые браузером на устройстве Пользователя, которые браузер передаёт веб-серверу при каждом последующем обращении к Сайту. Для целей настоящей Политики к файлам cookie приравниваются аналогичные технологии: пиксельные теги, веб-маяки, локальное хранилище браузера (localStorage, sessionStorage) и идентификаторы устройства."
        },
        {
          type: "clause",
          num: "3.17",
          text: "IP-адрес — уникальный сетевой адрес узла в компьютерной сети, построенной по протоколу IP."
        }
      ]
    },
    {
      id: "4",
      title: "ПРИНЦИПЫ И ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ",
      blocks: [
        {
          type: "clause",
          num: "4.1",
          text: "Обработка персональных данных осуществляется Оператором на законной и справедливой основе с соблюдением следующих принципов:",
          items: [
            "соблюдение конституционных прав и свобод человека и гражданина;",
            "законность обработки и её ограничение конкретными, заранее определёнными и законными целями;",
            "недопустимость обработки персональных данных, несовместимой с целями их сбора;",
            "соответствие объёма и содержания обрабатываемых персональных данных заявленным целям обработки; обработка только того минимума данных, который необходим для достижения цели;",
            "достоверность персональных данных, их достаточность и актуальность по отношению к целям обработки;",
            "конфиденциальность персональных данных ограниченного доступа;",
            "хранение персональных данных не дольше, чем этого требуют цели обработки, если иной срок не установлен законодательством Республики Казахстан или договором."
          ]
        },
        {
          type: "clause",
          num: "4.2",
          text: "Правовыми основаниями обработки персональных данных являются:",
          items: [
            "согласие субъекта персональных данных или его законного представителя;",
            "заключение и исполнение договора, стороной которого является субъект персональных данных, в том числе договора розничной купли-продажи, заключаемого на условиях публичной оферты, а также договора оказания сервисных услуг;",
            "исполнение обязанностей, возложенных на Оператора законодательством Республики Казахстан, в том числе законодательством о бухгалтерском учёте и финансовой отчётности, налоговым законодательством и законодательством о защите прав потребителей;",
            "иные случаи, прямо предусмотренные статьёй 9 Закона о персональных данных, когда сбор и обработка осуществляются без согласия субъекта."
          ]
        },
        {
          type: "clause",
          num: "4.3",
          text: "Оператор не принимает в отношении Пользователя решений, порождающих юридические последствия или иным образом затрагивающих его права и законные интересы, исключительно на основании автоматизированной обработки персональных данных."
        }
      ]
    },
    {
      id: "5",
      title: "СОСТАВ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ",
      blocks: [],
      subsections: [
        {
          id: "5.1",
          title: "Данные, предоставляемые Пользователем самостоятельно",
          blocks: [
            {
              type: "clause",
              num: "5.1.1",
              text: "При оформлении заказа: фамилия и имя; контактный номер телефона; адрес электронной почты; адрес доставки (город, улица, дом, квартира, почтовый индекс); комментарий к заказу; фамилия, имя и номер телефона получателя, если заказ оформляется в пользу третьего лица."
            },
            {
              type: "clause",
              num: "5.1.2",
              text: "При регистрации и использовании личного кабинета: имя; адрес электронной почты (используется в качестве логина); номер телефона; пароль, хранимый в виде необратимого криптографического преобразования; история заказов, список избранных товаров и содержимое корзины."
            },
            {
              type: "clause",
              num: "5.1.3",
              text: "При подписке на рассылку: адрес электронной почты и (или) номер телефона."
            },
            {
              type: "clause",
              num: "5.1.4",
              text: "При публикации отзыва: имя или указанный Пользователем псевдоним; текст отзыва; изображения, прикрепляемые Пользователем (не более трёх). Пользователь понимает, что отзыв и приложенные к нему изображения размещаются на Сайте в открытом доступе, и самостоятельно определяет объём раскрываемых в нём сведений."
            },
            {
              type: "clause",
              num: "5.1.5",
              text: "При обращении в службу поддержки, в том числе через мессенджеры и социальные сети: имя, использованный канал связи и контактные данные в нём, содержание обращения и приложенные материалы."
            },
            {
              type: "clause",
              num: "5.1.6",
              text: "При направлении отклика на вакансию: фамилия, имя, отчество (при его наличии); контактный номер телефона; адрес электронной почты; сведения об образовании, квалификации и опыте работы; иные сведения, включённые кандидатом в резюме или сопроводительное письмо по собственному усмотрению."
            },
            {
              type: "clause",
              num: "5.1.7",
              text: "При обращении в сервисный центр: фамилия, имя, отчество (при его наличии); контактные данные; сведения об изделии, переданном на диагностику или ремонт, и о характере обращения."
            },
            {
              type: "clause",
              num: "5.1.8",
              text: "Дата рождения — при её добровольном указании Пользователем, для целей направления персональных предложений и поздравлений."
            },
            {
              type: "clause",
              num: "5.1.9",
              text: "При обслуживании в розничных бутиках сети и участии в программе лояльности: фамилия и имя; контактный номер телефона; сведения о совершённых покупках, необходимые для гарантийного обслуживания и предоставления скидок."
            }
          ]
        },
        {
          id: "5.2",
          title: "Данные, собираемые автоматически",
          blocks: [
            {
              type: "clause",
              num: "5.2.1",
              text: "При посещении Сайта Оператор автоматически получает и обрабатывает:",
              items: [
                "IP-адрес Пользователя;",
                "данные файлов cookie и аналогичных технологий, включая пиксельные теги и веб-маяки;",
                "сведения о браузере и устройстве Пользователя: тип и версия браузера, операционная система, тип устройства, разрешение экрана, язык интерфейса;",
                "дату и время обращения к Сайту, перечень просмотренных страниц и совершённых на Сайте действий, источник перехода на Сайт, поисковые запросы, введённые Пользователем в поиск по Сайту;",
                "выбранный Пользователем город доставки;",
                "сведения о примерном местонахождении на уровне населённого пункта, определяемые по IP-адресу, а также данные геолокации — при условии, что Пользователь предоставил соответствующее разрешение в браузере или на устройстве."
              ]
            }
          ]
        },
        {
          id: "5.3",
          title: "Данные, которые Оператор не обрабатывает",
          blocks: [
            {
              type: "clause",
              num: "5.3.1",
              text: "Оператор не осуществляет обработку биометрических данных, а также сведений о расовой и национальной принадлежности, политических взглядах, религиозных или философских убеждениях, состоянии здоровья, интимной жизни, судимости Пользователя."
            },
            {
              type: "clause",
              num: "5.3.2",
              text: "Оператор не собирает и не хранит реквизиты платёжных карт Пользователя. Оплата заказов производится на защищённых платёжных страницах банков-эквайеров и платёжных организаций: номер карты, срок её действия и код проверки подлинности вводятся Пользователем непосредственно на стороне банка или платёжной организации и Оператору не передаются. Оператор получает только сведения о результате платежа, его идентификаторе и сумме."
            }
          ]
        },
        {
          id: "5.4",
          title: "Прочие условия в отношении состава данных",
          blocks: [
            {
              type: "clause",
              num: "5.4.1",
              text: "Оператор не осуществляет целенаправленный сбор персональных данных лиц, не достигших восемнадцати лет. Обработка персональных данных несовершеннолетнего осуществляется с согласия его законного представителя. Если Оператору станет известно, что персональные данные несовершеннолетнего были получены без такого согласия, соответствующие данные подлежат уничтожению."
            },
            {
              type: "clause",
              num: "5.4.2",
              text: "Пользователь обязуется не размещать на Сайте персональные данные третьих лиц без их согласия, а равно сведения, не соответствующие требованиям законодательства Республики Казахстан и настоящей Политике. Указывая данные получателя заказа, Пользователь подтверждает наличие согласия такого лица на передачу его данных Оператору."
            },
            {
              type: "clause",
              num: "5.4.3",
              text: "Оператор не проверяет достоверность предоставляемых Пользователем персональных данных и не имеет возможности оценивать его дееспособность. Оператор исходит из того, что Пользователь предоставляет достоверные данные и поддерживает их в актуальном состоянии."
            }
          ]
        }
      ]
    },
    {
      id: "6",
      title: "ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ",
      blocks: [
        {
          type: "clause",
          num: "6.1",
          text: "Оператор обрабатывает персональные данные Пользователя в следующих целях:",
          items: [
            "идентификация Пользователя и предоставление доступа к персонализированным функциям Сайта;",
            "создание и обслуживание личного кабинета Пользователя;",
            "оформление, обработка и исполнение заказов, включая комплектование, доставку и приём оплаты товара;",
            "связь с Пользователем по вопросам заказа, направление уведомлений о его статусе, запросов и иной сервисной информации;",
            "гарантийное и сервисное обслуживание приобретённых товаров, рассмотрение обращений о возврате и обмене товара;",
            "рассмотрение обращений, претензий и запросов Пользователя, в том числе поступивших через мессенджеры и социальные сети;",
            "хранение сведений о товарах, добавленных Пользователем в разделы «Избранное» и «Корзина», в том числе без регистрации на Сайте;",
            "публикация отзывов Пользователя о товарах и обслуживании;",
            "направление информационных и рекламных рассылок, сведений об акциях, специальных предложениях и новинках — исключительно при наличии отдельно выраженного согласия Пользователя;",
            "администрирование программы лояльности и предоставление персональных скидок;",
            "рассмотрение отклика кандидата на вакансию и связь с ним по вопросам трудоустройства;",
            "определение города Пользователя для отображения релевантных условий доставки и наличия товара в бутиках;",
            "улучшение работы Сайта, удобства его использования и разработка новых функций;",
            "проведение статистических и маркетинговых исследований, в том числе на основе обезличенных данных, анализ посещаемости и эффективности рекламных каналов;",
            "таргетирование рекламных материалов;",
            "обеспечение информационной безопасности Сайта, выявление и предотвращение мошеннических действий и злоупотреблений;",
            "исполнение обязанностей, возложенных на Оператора законодательством Республики Казахстан, а также защита прав и законных интересов Оператора и Пользователя."
          ]
        },
        {
          type: "clause",
          num: "6.2",
          text: "Обработка персональных данных в целях, не предусмотренных настоящей Политикой, не осуществляется. При возникновении необходимости обработки данных в новых целях Оператор запрашивает согласие Пользователя."
        }
      ]
    },
    {
      id: "7",
      title: "ПОРЯДОК ПОЛУЧЕНИЯ, СРОК ДЕЙСТВИЯ И ОТЗЫВ СОГЛАСИЯ",
      blocks: [
        {
          type: "clause",
          num: "7.1",
          text: "Согласие Пользователя на сбор и обработку персональных данных предоставляется в электронной форме способом, позволяющим подтвердить факт его получения Оператором. Совершение действий, перечисленных ниже, признаётся выражением согласия только при условии, что соответствующая форма Сайта содержит предусмотренное пунктом 7.2 подтверждение согласия:",
          items: [
            "регистрация личного кабинета на Сайте;",
            "оформление заказа на Сайте, в том числе без регистрации;",
            "подписка на рассылку с помощью формы, размещённой на Сайте;",
            "направление отзыва, обращения в службу поддержки либо отклика на вакансию;",
            "введение персональных данных в иных случаях, когда это предусмотрено функциями Сайта."
          ]
        },
        {
          type: "clause",
          num: "7.2",
          text: "При совершении действий, указанных в пункте 7.1, Пользователь проставляет отдельную, не установленную заранее отметку в поле о согласии на сбор и обработку персональных данных. До предоставления согласия Пользователю должна быть доступна информация, предусмотренная законодательством Республики Казахстан, включая сведения об Операторе и его БИН, перечень собираемых данных, цели обработки, срок или период действия согласия, возможность передачи данных третьим лицам, наличие либо отсутствие трансграничной передачи и распространения персональных данных в общедоступных источниках. Текст согласия может содержаться в отдельной электронной форме либо включаться посредством прямой ссылки на документ, являющийся неотъемлемой частью механизма получения согласия. Отсутствие отметки препятствует обработке данных в случаях, когда такая обработка требует согласия субъекта."
        },
        {
          type: "clause",
          num: "7.3",
          text: "Согласие на обработку персональных данных предоставляется на срок, необходимый для достижения целей обработки, указанных в разделе 6 настоящей Политики, и действует до его отзыва Пользователем либо до истечения сроков хранения, предусмотренных разделом 10 настоящей Политики."
        },
        {
          type: "clause",
          num: "7.4",
          text: "Пользователь вправе в любой момент отозвать согласие на сбор и обработку персональных данных, уведомив об этом Оператора способом, указанным в пункте 2.3 настоящей Политики. В течение пятнадцати рабочих дней с момента получения уведомления Оператор обязан прекратить обработку персональных данных, если их хранение или обработка не требуется в соответствии с законодательством Республики Казахстан, либо представить Пользователю мотивированный отказ."
        },
        {
          type: "clause",
          num: "7.5",
          text: "Отзыв согласия не распространяется на персональные данные, обработка которых необходима для исполнения неисполненного обязательства перед Пользователем, а также на данные, срок хранения которых установлен законодательством Республики Казахстан."
        },
        {
          type: "clause",
          num: "7.6",
          text: "Согласие на получение рекламных рассылок предоставляется Пользователем отдельно и независимо от согласия на обработку персональных данных в целях исполнения заказа. Пользователь вправе в любое время отказаться от получения рекламной информации, воспользовавшись ссылкой отписки в письме либо направив соответствующее обращение Оператору. Отказ от рекламной рассылки не влияет на получение сервисных уведомлений, связанных с исполнением заказа."
        },
        {
          type: "clause",
          num: "7.7",
          text: "Пользователю предоставлена возможность самостоятельного доступа, просмотра и редактирования части своих персональных данных путём внесения изменений в личный кабинет."
        }
      ]
    },
    {
      id: "8",
      title: "ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ ТРЕТЬИМ ЛИЦАМ",
      blocks: [
        {
          type: "clause",
          num: "8.1",
          text: "Оператор передаёт персональные данные третьим лицам только в объёме, необходимом для достижения целей, указанных в разделе 6 настоящей Политики, и только при наличии согласия Пользователя либо иного законного основания."
        },
        {
          type: "clause",
          num: "8.2",
          text: "Персональные данные могут передаваться следующим категориям получателей:",
          items: [
            "службам доставки и курьерским службам — в объёме, необходимом для доставки заказа (фамилия, имя, номер телефона, адрес доставки);",
            "платёжным организациям, обеспечивающим приём оплаты, в том числе Kaspi Pay / Kaspi Bank, Alatau City Bank, TipTop Pay, — в объёме, необходимом для проведения платежа и его подтверждения;",
            "поставщикам услуг хостинга, технической поддержки, резервного копирования и информационной безопасности;",
            "поставщикам сервисов веб-аналитики и рекламных сервисов — в объёме сведений, указанных в пунктах 5.2 и 11.4 настоящей Политики;",
            "операторам сервисов рассылок и мессенджеров, используемых для направления уведомлений и обращений;",
            "авторизованным сервисным центрам и представителям производителей часов — в объёме, необходимом для гарантийного обслуживания;",
            "государственным органам и иным лицам — в случаях и объёме, прямо предусмотренных законодательством Республики Казахстан."
          ]
        },
        {
          type: "clause",
          num: "8.3",
          text: "Передача персональных данных третьим лицам осуществляется при условии принятия ими обязательств по соблюдению конфиденциальности и требований законодательства Республики Казахстан о защите персональных данных."
        },
        {
          type: "clause",
          num: "8.4",
          text: "Передача персональных данных ограниченного доступа иным лицам осуществляется по защищённым каналам связи и (или) с применением шифрования."
        },
        {
          type: "clause",
          num: "8.5",
          text: "Оператор ведёт регистрацию и учёт действий, совершаемых с персональными данными в рамках выданного Пользователем согласия, в том числе фиксирует факты передачи персональных данных третьим лицам, трансграничной передачи и распространения персональных данных в общедоступных источниках, а также соблюдение срока действия согласия."
        },
        {
          type: "clause",
          num: "8.6",
          text: "Информация о передаче персональных данных третьим лицам, а также о доступе третьих лиц к персональным данным предоставляется и (или) доводится до сведения Пользователя в случаях, порядке и объёме, установленных Законом о персональных данных и принятыми в его реализацию нормативными правовыми актами."
        },
        {
          type: "clause",
          num: "8.7",
          text: "Оператор не продаёт персональные данные Пользователей и не передаёт их третьим лицам в целях, не связанных с исполнением обязательств перед Пользователем и не предусмотренных настоящей Политикой."
        }
      ]
    },
    {
      id: "9",
      title: "МЕСТО ХРАНЕНИЯ ДАННЫХ И ТРАНСГРАНИЧНАЯ ПЕРЕДАЧА",
      blocks: [
        {
          type: "clause",
          num: "9.1",
          text: "Накопление и хранение персональных данных осуществляются в базе, находящейся на территории Республики Казахстан. При использовании иностранных сервисов Оператор обеспечивает соблюдение требования о хранении базы на территории Республики Казахстан и применимых требований к трансграничной передаче персональных данных."
        },
        {
          type: "clause",
          num: "9.2",
          text: "При использовании отдельных сторонних сервисов, необходимых для функционирования Сайта и связи с Пользователем, осуществляется трансграничная передача части данных."
        },
        {
          type: "clause",
          num: "9.2.1",
          text: "Сервисы веб-аналитики. Для сбора обезличенной статистики посещаемости Сайта используется сервис «Яндекс.Метрика», владельцем которого является ООО «Яндекс». При этом передаются сведения, указанные в пункте 5.2 настоящей Политики. Обработка таких сведений осуществляется владельцем сервиса на серверах, расположенных за пределами Республики Казахстан, в соответствии с его собственными правилами и условиями использования."
        },
        {
          type: "clause",
          num: "9.2.2",
          text: "Мессенджеры и социальные сети. При обращении Пользователя к Оператору через WhatsApp, Telegram или Instagram по собственной инициативе Пользователя обрабатываются данные его учётной записи в соответствующем сервисе и содержание переписки. Указанные сервисы принадлежат иностранным лицам и осуществляют обработку данных за пределами Республики Казахстан в соответствии с собственными правилами. Пользователь вправе вместо мессенджеров использовать телефон или электронную почту Оператора, указанные в разделе 2 настоящей Политики."
        },
        {
          type: "clause",
          num: "9.3",
          text: "Оператор передаёт в сервисы, указанные в пункте 9.2, минимально необходимый объём данных и не передаёт им сведения о заказах, платежах и содержании личного кабинета Пользователя."
        },
        {
          type: "clause",
          num: "9.4",
          text: "Трансграничная передача персональных данных осуществляется при наличии согласия Пользователя и при условии обеспечения принимающей стороной защиты персональных данных, за исключением случаев, предусмотренных статьёй 16 Закона о персональных данных."
        },
        {
          type: "clause",
          num: "9.5",
          text: "Пользователь вправе ограничить сбор данных сервисами веб-аналитики способами, указанными в разделе 11 настоящей Политики."
        }
      ]
    },
    {
      id: "10",
      title: "СРОКИ ХРАНЕНИЯ ПЕРСОНАЛЬНЫХ ДАННЫХ",
      blocks: [
        {
          type: "clause",
          num: "10.1",
          text: "Персональные данные хранятся не дольше, чем этого требуют цели их обработки, если иной срок не установлен законодательством Республики Казахстан или договором. Устанавливаются следующие ориентировочные сроки хранения:",
          items: [
            "данные, связанные с заказом и его оплатой, — в течение срока действия гарантии на приобретённый товар и срока исковой давности, а также в течение срока, установленного законодательством Республики Казахстан о бухгалтерском учёте и финансовой отчётности;",
            "данные личного кабинета — до момента удаления учётной записи Пользователем либо отзыва согласия;",
            "адрес электронной почты и номер телефона, используемые для рассылки, — до момента отказа Пользователя от её получения;",
            "данные, содержащиеся в отклике на вакансию, — не более шести месяцев с момента получения отклика, если кандидат не выразил согласия на более длительное хранение;",
            "данные обращений в службу поддержки и сервисный центр — не более трёх лет с даты завершения их рассмотрения;",
            "данные, содержащиеся в опубликованных отзывах, — до момента удаления отзыва по обращению Пользователя или по решению Оператора;",
            "данные файлов cookie — в соответствии со сроком жизни каждого файла, но не более двенадцати месяцев для аналитических и рекламных файлов; сессионные файлы удаляются при закрытии браузера."
          ]
        },
        {
          type: "clause",
          num: "10.2",
          text: "По достижении целей обработки, а также по истечении сроков, указанных в пункте 10.1, персональные данные подлежат уничтожению либо обезличиванию."
        }
      ]
    },
    {
      id: "11",
      title: "ФАЙЛЫ COOKIE И АНАЛОГИЧНЫЕ ТЕХНОЛОГИИ",
      blocks: [
        {
          type: "clause",
          num: "11.1",
          text: "Сайт использует файлы cookie и аналогичные технологии для обеспечения корректной работы Сайта, его отображения на устройстве Пользователя, запоминания предпочтений, ведения статистики посещаемости и показа релевантной рекламы."
        },
        {
          type: "clause",
          num: "11.2",
          text: "Оператор использует следующие категории файлов cookie:",
          items: [
            "строго необходимые — обеспечивают базовую работоспособность Сайта: авторизацию в личном кабинете, сохранение содержимого корзины, выбор города, защиту от несанкционированных действий. Отключение таких файлов делает использование Сайта невозможным;",
            "функциональные — сохраняют пользовательские настройки и предпочтения, список избранных товаров, ранее просмотренные позиции;",
            "аналитические — позволяют собирать обезличенную статистику о посещаемости Сайта, источниках переходов и поведении Пользователей для улучшения работы Сайта;",
            "рекламные (маркетинговые) — используются для оценки эффективности рекламных кампаний и показа релевантных рекламных материалов на Сайте и на сторонних ресурсах."
          ]
        },
        {
          type: "clause",
          num: "11.3",
          text: "Оператор собирает информацию с помощью файлов cookie в целях: обеспечения корректной работы Сайта; идентификации Пользователя без регистрации; предоставления доступа к персонализированным функциям без авторизации; учёта статистики посещаемости; анализа перемещений и действий Пользователя на Сайте; хранения сведений о товарах, добавленных в разделы «Избранное» и «Корзина»; хранения поисковых запросов Пользователя на Сайте; отображения рекламы."
        },
        {
          type: "clause",
          num: "11.4",
          text: "Для сбора обезличенной статистики Сайт использует сервис веб-аналитики «Яндекс.Метрика». Указанный сервис собирает электронные данные (HTTP-заголовки, IP-адрес, файлы cookie, веб-маяки и пиксельные теги, идентификатор браузера, сведения об аппаратном и программном обеспечении), дату и время обращения к Сайту, сведения об активности Пользователя на Сайте и данные о примерной геолокации. Обработка указанных данных осуществляется владельцем сервиса в соответствии с его собственными правилами."
        },
        {
          type: "clause",
          num: "11.5",
          text: "Сведения об IP-адресе собираются Оператором также в целях выявления и устранения технических проблем и обеспечения безопасности Сайта."
        },
        {
          type: "clause",
          num: "11.6",
          text: "Пользователь вправе отказаться от использования файлов cookie, изменив настройки браузера, либо удалить ранее сохранённые файлы. В этом случае часть функций Сайта может стать недоступной или работать некорректно. Для отказа от сбора данных сервисами веб-аналитики Пользователь может воспользоваться специализированными расширениями браузера, предоставляемыми владельцами таких сервисов."
        },
        {
          type: "clause",
          num: "11.7",
          text: "Информация, собранная с помощью файлов cookie и сведения об IP-адресе, сама по себе не позволяет идентифицировать личность Пользователя. В случае, когда такая информация дополняется идентификаторами персональных данных, она обрабатывается Оператором как персональные данные в соответствии с настоящей Политикой."
        }
      ]
    },
    {
      id: "12",
      title: "ПРАВА ПОЛЬЗОВАТЕЛЯ И ПОРЯДОК ОБРАЩЕНИЯ",
      blocks: [
        {
          type: "clause",
          num: "12.1",
          text: "Пользователь как субъект персональных данных имеет право:",
          items: [
            "знать о наличии у Оператора своих персональных данных, а также получать информацию о составе таких данных, целях, источниках и способах их обработки, сроках хранения и лицах, которым они передавались;",
            "требовать изменения, дополнения и уточнения своих персональных данных, если они являются неполными, устаревшими или недостоверными;",
            "требовать блокирования или уничтожения своих персональных данных, если они получены с нарушением законодательства Республики Казахстан либо являются излишними по отношению к целям обработки;",
            "отозвать согласие на сбор и обработку персональных данных;",
            "отказаться от получения рекламных рассылок;",
            "защищать свои права и законные интересы, в том числе требовать возмещения морального и имущественного вреда;",
            "обжаловать действия или бездействие Оператора в уполномоченный орган в сфере защиты персональных данных либо в судебном порядке."
          ]
        },
        {
          type: "clause",
          num: "12.2",
          text: "Для реализации своих прав Пользователь направляет обращение способом, указанным в пункте 2.3 настоящей Политики. В обращении рекомендуется указать фамилию и имя, контактные данные, использованные при взаимодействии с Оператором (адрес электронной почты и (или) номер телефона), а также существо требования. Оператор вправе запросить дополнительные сведения, необходимые для идентификации обратившегося лица, чтобы исключить предоставление персональных данных ненадлежащему лицу."
        },
        {
          type: "clause",
          num: "12.3",
          text: "Обращения рассматриваются Оператором в порядке и сроки, установленные Законом о персональных данных и иными применимыми нормативными правовыми актами Республики Казахстан."
        },
        {
          type: "clause",
          num: "12.4",
          text: "В случае отказа в удовлетворении требования Пользователя Оператор представляет мотивированный ответ с указанием оснований отказа."
        }
      ]
    },
    {
      id: "13",
      title: "МЕРЫ ПО ОБЕСПЕЧЕНИЮ БЕЗОПАСНОСТИ ПЕРСОНАЛЬНЫХ ДАННЫХ",
      blocks: [
        {
          type: "clause",
          num: "13.1",
          text: "Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения и иных неправомерных действий, в том числе:",
          items: [
            "определяет и контролирует перечень работников, имеющих доступ к персональным данным, с разграничением прав доступа в зависимости от исполняемых обязанностей;",
            "назначает лицо, ответственное за организацию обработки персональных данных;",
            "доводит до сведения работников требования законодательства Республики Казахстан о персональных данных и локальных актов Оператора, обеспечивает их обучение;",
            "применяет организационные и технические средства защиты информации, включая шифрование при передаче данных, защищённое соединение (протокол HTTPS), парольную защиту и резервное копирование;",
            "обеспечивает своевременное выявление фактов несанкционированного доступа к персональным данным и принимает меры по минимизации неблагоприятных последствий;",
            "осуществляет внутренний контроль соответствия обработки персональных данных требованиям законодательства;",
            "предоставляет доступ государственной технической службе к цифровым объектам, используемым для хранения, обработки и распространения персональных данных ограниченного доступа, в целях проведения обследования их защищённости в порядке, определяемом уполномоченным органом."
          ]
        },
        {
          type: "clause",
          num: "13.2",
          text: "С момента обнаружения нарушения безопасности персональных данных Оператор уведомляет уполномоченный орган в сфере защиты персональных данных о таком нарушении с указанием контактных данных лица, ответственного за организацию обработки персональных данных (при наличии), в порядке, установленном законодательством Республики Казахстан. Уведомление затронутых субъектов персональных данных осуществляется в случаях и порядке, предусмотренных Законом о персональных данных и Правилами осуществления уведомления субъектов персональных данных о нарушении безопасности персональных данных."
        },
        {
          type: "clause",
          num: "13.3",
          text: "Пользователь несёт ответственность за сохранность своего логина и пароля от личного кабинета и обязуется не передавать их третьим лицам. Все действия, совершённые в личном кабинете с использованием учётных данных Пользователя, считаются совершёнными Пользователем."
        },
        {
          type: "clause",
          num: "13.4",
          text: "Оператор не несёт ответственности за сохранность персональных данных Пользователя в случаях, когда их разглашение произошло вследствие действий третьих лиц, находящихся вне разумного контроля Оператора, в том числе вследствие вирусной или хакерской атаки, при условии, что Оператором были приняты меры защиты, предусмотренные настоящим разделом и требуемые законодательством Республики Казахстан."
        }
      ]
    },
    {
      id: "14",
      title: "ССЫЛКИ НА СТОРОННИЕ РЕСУРСЫ",
      blocks: [
        {
          type: "clause",
          num: "14.1",
          text: "Сайт может содержать ссылки на сайты третьих лиц, в том числе на сайты партнёров Оператора и официальных представительств часовых брендов. Оператор не контролирует такие сайты и не несёт ответственности за содержание размещённой на них информации, а также за обработку персональных данных их владельцами."
        },
        {
          type: "clause",
          num: "14.2",
          text: "Переходя по ссылке на сторонний ресурс, Пользователь принимает на себя риски, связанные с обработкой его данных владельцем такого ресурса, и самостоятельно знакомится с применяемой на нём политикой конфиденциальности."
        }
      ]
    },
    {
      id: "15",
      title: "ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ",
      blocks: [
        {
          type: "clause",
          num: "15.1",
          text: "Оператор вправе вносить изменения в настоящую Политику в одностороннем порядке. Новая редакция вступает в силу с момента её размещения по адресу https://g-factory.kz/privacyPolicy, если иное не предусмотрено новой редакцией."
        },
        {
          type: "clause",
          num: "15.2",
          text: "Пользователю рекомендуется периодически знакомиться с действующей редакцией Политики. Размещение новой редакции Политики само по себе не заменяет получение нового согласия Пользователя, если изменения предполагают сбор или обработку дополнительных персональных данных, изменение целей обработки, условий передачи третьим лицам, трансграничной передачи, распространения либо иные изменения, для которых законодательством Республики Казахстан требуется согласие субъекта."
        },
        {
          type: "clause",
          num: "15.3",
          text: "К настоящей Политике и отношениям, возникающим в связи с её применением, подлежит применению право Республики Казахстан."
        },
        {
          type: "clause",
          num: "15.4",
          text: "Пользователь и Оператор несут ответственность за нарушение условий настоящей Политики в соответствии с законодательством Республики Казахстан."
        },
        {
          type: "clause",
          num: "15.5",
          text: "Все споры, вытекающие из настоящей Политики, разрешаются путём переговоров, а при недостижении согласия — в судебном порядке в соответствии с процессуальным законодательством Республики Казахстан."
        },
        {
          type: "clause",
          num: "15.6",
          text: "Если какое-либо положение настоящей Политики будет признано недействительным, это не влияет на действительность остальных её положений."
        },
        {
          type: "clause",
          num: "15.7",
          text: "Настоящая Политика действует в редакции от «10» сентября 2026 года."
        }
      ]
    }
  ],
  requisites: {
    title: "РЕКВИЗИТЫ ОПЕРАТОРА",
    fields: [
      {
        label: "Наименование",
        value: "Товарищество с ограниченной ответственностью «Chronos Trading»"
      },
      {
        label: "БИН",
        value: "110440018801"
      },
      {
        label: "Юридический адрес",
        value: "Республика Казахстан, город Алматы, улица Желтоксан, дом 148"
      },
      {
        label: "Сайт",
        value: "https://g-factory.kz"
      },
      {
        label: "Электронная почта для обращений по вопросам персональных данных",
        value: "shop@g-factory.kz"
      },
      {
        label: "Абонентские номера",
        value: "+7 (777) 393 80 22"
      },
      {
        label: "Ответственный за организацию обработки персональных данных",
        value: "лицо, назначаемое приказом руководителя Оператора; обращения направляются на shop@g-factory.kz с пометкой «Персональные данные»"
      }
    ]
  }
};

export default privacyPolicy;